var exports = {
  "k": "xcc377c0b--8648cc--container",
};

module.exports = exports;
